import React, { useState } from "react";

import { Button } from "../ui/button";
import moment from "moment";
import { getItemInfo } from "../cache/itemData";
const formatNumber = (value) => new Intl.NumberFormat().format(value);

export const ValueCell = (props) => {
  const { value = 0, type } = props;

  let colorData = value > 0 ? "#cf1322" : value < 0 ? "#0958d9" : "#000";

  if (type === 0) colorData = "#000";
  if (type === 1) colorData = "#0958d9";
  return (
    <div style={{ color: colorData }} className="text-right mr-1">
      {value !== null ? value.toLocaleString() : 0}
    </div>
  );
};

export const StringValueCell = ({ value, alignment = "center" }) => {
  return (
    <div style={{ textAlign: alignment }}>
      {value.toFixed(0)}
    </div>
  );
};

// 원화 cellRenderer
export const ValueCellRender = (props) => {
  const { displayValue, value, color, type } = props;

  let colorData;
  
  if (typeof color === "string") {
    colorData = color;
  } else {
    const currentValue = displayValue !== undefined ? displayValue : value;
    
    if (currentValue === 0 || currentValue === null || currentValue === undefined) {
      // 값이 0이거나 null/undefined일 때는 항상 검정색
      colorData = "#000";
    } else if (type === 1) {
      // 수수료 타입이고 0이 아닐 때는 파란색
      colorData = "#0958d9";
    } else if (currentValue < 0) {
      // 음수일 때는 파란색
      colorData = "#0958d9";
    } else {
      // 양수일 때는 빨간색
      colorData = "#ff0000";
    }
  }

  return (
    <div style={{ color: colorData }} className="text-right mr-1">
      {displayValue !== undefined && displayValue !== null
        ? displayValue.toLocaleString()
        : value !== undefined && value !== null
        ? value.toLocaleString()
        : 0}
    </div>
  );
};

// 상태 cellRenderer
export const StatusCellRender = (props) => {
  const { value } = props;
  const displayValue = value === 0 ? "승인대기" : value === 1 ? "승인" : "거절";

  const backgroundColor = value === 0 ? "#ff9800" : value === 1 ? "#4caf50" : "#f44336";
  return (
    <div className="-mx-3 -my-1.5 px-3 py-1.5 text-white text-center" style={{ backgroundColor }}>
      {displayValue}
    </div>
  );
};

// 회원등급
export const MemberGradeCellRender = (props) => {
  const { value } = props;

  const displayValue =
    value === 0
      ? "준회원"
      : value === 1
      ? "정회원"
      : value === 2
      ? "추천인"
      : value === 3
      ? "관리자"
      : value === 4
      ? "테스터"
      : value === 5
      ? "모의투자"
      : value;

  const cellContainerValue =
    displayValue === "준회원"
      ? 0
      : displayValue === "정회원"
      ? 1
      : displayValue === "추천인"
      ? 2
      : displayValue === "관리자"
      ? 3
      : displayValue === "테스터"
      ? 4
      : displayValue === "모의투자"
      ? 5
      : 6;
  return (
    <div
      className={`text-center ${cellContainerValue === 0 ? "-mx-3 -my-1.5 px-3 py-1.5 bg-[#ff9800] text-white" : ""}`}
    >
      {displayValue}
    </div>
  );
};

// member
export const MemberGradeCell = ({ value }) => {
  return (
    <div
      className={`text-center ${value === "준회원" ? "bg-[#ff9800] text-white" : ""}`}
    >
      {value}
    </div>
  );
};

// 승인 cellRenderer
export const ApproveCellRender = (props) => {
  const {
    data: { id, status },
    handleApproveClick,
    handleRefuseClick,
  } = props;

  const color = status === 1 ? "#4caf50" : "#f44336";

  return (
    <div className="text-center" style={{ color }}>
      {status === 1 ? (
        "승인완료"
      ) : status === 2 ? (
        "거절완료"
      ) : (
        <>
          <Button
            className="bg-green-600 text-white hover:bg-green-700"
            onClick={(props) => handleApproveClick({ ...props, id })}
          >
            승인
          </Button>
          <Button
            className="bg-red-600 text-white hover:bg-red-700"
            onClick={(props) => handleRefuseClick({ ...props, id })}
          >
            거절
          </Button>
        </>
      )}
    </div>
  );
};
// Summary 를 위한 totalItem Custom

// 매수 매도
export const IsBuyCellRender = (props) => {
  const { value } = props;
  if (value === null) return null;
  return (
    <span className={value ? "text-trading-buy" : "text-trading-sell"}>
      {value ? "매수" : "매도"}
    </span>
  );
};

// 상태
export const OrderStatusCellRender = (props) => {
  const { value } = props;
  let status = "",
    color = "#000";

  switch (value) {
    case 0:
      status = "취소";
      color = "#f44336";
      break;
    case 1:
      status = "신규";
      break;
    case 2:
      status = "정정";
      color = "#ff9800";
      break;
    case 3:
      status = "체결";
      color = "#4caf50";
      break;
    case 4:
      status = "체결";
      color = "#4caf50";
      break;
    default:
      status = null;
  }
  return (
    <span style={{ color }}>{status}</span>
  );
};

// 청산 버튼
export const ConcludeButton = (props) => {
  const { concludeOrder, managerId } = props;

  const handleConcludeOrder = () => {
    const { id, orderNo } = props.data;

    concludeOrder({
      variables: {
        managerId,
        userId: id || props.data.userId,
        orderNo,
        concludePrice: getItemInfo(props.data.itemCode).real_sign.price,
      },
    });
  };

  return (
    <div
      className="text-white h-9 flex justify-center items-center cursor-pointer"
      style={{ background: "#4caf50" }}
      onClick={() => handleConcludeOrder()}
    >
      <div>청산</div>
    </div>
  );
};

export const CancelButton = (props) => {
  const { cancelOrder, managerId } = props;

  const handleCancelOrder = () => {
    const { id, orderNo } = props.data;

    cancelOrder({
      variables: {
        managerId,
        userId: id,
        orderNo,
      },
    });
  };
  return (
    <div
      className="text-white h-9 flex justify-center items-center cursor-pointer"
      style={{ background: "#f44336" }}
      onClick={() => handleCancelOrder()}
    >
      <div>취소</div>
    </div>
  );
};

export const CustomFormItem = (props) => {
  if (props.prefix && props.suffix)
    return (
      <>
        <span>{prefix}</span>
        <input className="border rounded px-2 py-1 w-full" value={props.value} readOnly />
        <span>{suffix}</span>
      </>
    );
  if (props.prefix)
    return (
      <>
        <span>{prefix}</span>
        <input className="border rounded px-2 py-1 w-full" value={props.value} readOnly />
      </>
    );
  if (props.suffix)
    return (
      <>
        <input className="border rounded px-2 py-1 w-full" value={props.value} readOnly />
        <span>{suffix}</span>
      </>
    );

  return <input className="border rounded px-2 py-1 w-full" value={props.value} readOnly />;
};

export const BalanceCell = ({ value }) => {
  return <div className="text-right pr-2">{value.toLocaleString()}</div>;
};

// priceCell
export const PriceCell = ({ value, data }) => {
  if (isNaN(value)) return <div>{value}</div>;
  return <div>{parseFloat(value).toFixed(data.digit)}</div>;
};

// nested user id cell
export const UserIdCell = ({ value }) => {
  const { user } = value;
  return <div>{user.id}</div>;
};

// nested user name cell
export const UserNameCell = ({ value }) => {
  const { user } = value;

  return <div>{user.userName}</div>;
};

export const DateCell = ({ value, type }) => {
  if (value === null) return <></>;
  if (value === "합계") return <span>합계</span>;

  const date = typeof value === "number" ? `${value}` : value;

  const convertedDate =
    type === 0
      ? moment(parseInt(value)).format("YYYY-MM-DD HH:mm:ss")
      : `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
  return <span>{convertedDate}</span>;
};

export const ValueCellForEditable = ({ item, onChange, form }) => {
  const [value, setValue] = useState(item.entity[item.dataIndex]);

  const title = value
    ? value !== "-"
      ? formatNumber(Number(value))
      : "-"
    : "값을 입력하세요";
  const handleValueChange = (val) => {
    if (form && form.setFieldsValue) {
      const fieldValues = {};
      fieldValues[item.dataIndex] = val;
      form.setFieldsValue(fieldValues);
    }

    if (typeof onChange === "function") {
      onChange(val);
    }

    setValue(val);
  };
  return (
    <input
      className="border rounded px-2 py-1 w-full"
      title={title}
      value={value}
      onChange={(e) => {
        handleValueChange(e.target.value);
      }}
    />
  );
};

// 입출금 구분 cellRenderer
export const DepositTypeCellRender = (props) => {
  const { value } = props;
  const displayValue = value ? "입금" : "출금";
  const color = value ? "#1890ff" : "#ff4d4f";

  return (
    <span className="font-medium" style={{ color }}>
      {displayValue}
    </span>
  );
};
